import { AlertProvider, AuthProvider, ErrorStatusProvider, LayoutProvider, ModalProvider } from './contexts';

import { AppErrorBoundary } from './components/error';
import { AppRouter } from './routers';
import { Layout } from './components';
import React from 'react';

function App() {
  return (
    <div className="App">
      <AppErrorBoundary>
        <ModalProvider>
          <AlertProvider>
            <AuthProvider>
              <LayoutProvider>
                <Layout>
                  <ErrorStatusProvider>
                    <AppRouter />
                  </ErrorStatusProvider>
                </Layout>
              </LayoutProvider>
            </AuthProvider>
          </AlertProvider>
        </ModalProvider>
      </AppErrorBoundary>
    </div>
  );
}

export default App;
